import React from 'react';

import { LiveShoutout } from '../utils/Shoutouts';

import './ShoutoutTickerItem.scss';

interface ShoutoutTickerItemProps {
  shoutout: LiveShoutout;
}

/**
 * A paid shout-out in the TV ticker: "📣 username: message" on a coral pill, so the room can
 * tell it from the venue's own lines. It lives inside the ticker strip, below the video,
 * never over it.
 */
const ShoutoutTickerItem = ({ shoutout }: ShoutoutTickerItemProps) => (
  <span className="playerticker-item playerticker-shoutout-wrap">
    <span className="playerticker-shoutout">
      <span className="playerticker-shoutout-badge" aria-hidden="true">
        📣
      </span>
      {shoutout.username && <span className="playerticker-shoutout-name">{shoutout.username}:</span>}
      <span className="playerticker-shoutout-text">{shoutout.message}</span>
    </span>
  </span>
);

export default ShoutoutTickerItem;
